// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1U_3i","boxTitle":"Qualiphy_boxTitle__1GCYo","box":"Qualiphy_box__Tev1j","toggleWrap":"Qualiphy_toggleWrap__2iKvD"};